import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './DuePaymentsComponent.css';
import _ from 'lodash';
import UniversitiesDuePaymentsList from '../duePaymentsList/UniversitiesDuePaymentsList.container';
import BAsDuePaymentsList from '../duePaymentsList/BAsDuePaymentsList.container';
import SystemDuePaymentsList from '../duePaymentsList/SystemDuePaymentsList.container';
import FormWrapper from '../../../commonComponents/formWrapper/FormWrapper.container';

class DuePaymentsComponent extends Component {
    render() {
        return (
            <div className='due-payments-component-container'>
                <FormWrapper successMessage={_.get(this.props.translation, 'system_payment.due_payments_paid_success_message')}>
                    <h4 className="page-label">{_.get(this.props.translation, 'system_payment.due_payments_label')}</h4>
                    <h5 className="system-payment-subtitle olive-green">{_.get(this.props.translation, 'system_payment.system_due_payments_label')}</h5>
                    <SystemDuePaymentsList />
                    <h5 className="system-payment-subtitle olive-green">{_.get(this.props.translation, 'system_payment.ba_s_due_payments_label')}</h5>
                    <BAsDuePaymentsList />
                    <h5 className="system-payment-subtitle olive-green">{_.get(this.props.translation, 'system_payment.uni_s_due_payments_label')}</h5>
                    <UniversitiesDuePaymentsList />
                </FormWrapper>
            </div>
        )
    }
}

DuePaymentsComponent.propTypes = {
    translation: PropTypes.object.isRequired
};

export default DuePaymentsComponent;



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/duePaymentsComponent/DuePaymentsComponent.js